import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Category } from '../models/category.model';
import { EgiftCardsGatewayService } from './e-gift-cards-gateway.service';
import { ProductsResult } from '../models/product-result.model';
import { OrderList, Product } from '../models/order-list.model';
import { ReportParams } from '../models/report-params.model';
import { DigitalProductReport } from '../models/digital-product-report.model';
import { User } from 'src/app/shared/models/user.model';

interface QueryParams {
  key: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})

export class EgiftCardsFacadeService {

  public productList = new BehaviorSubject<boolean>(false)

  constructor(private eGiftCardsGatewayService: EgiftCardsGatewayService) { }

  getProductListSubject(): Observable<boolean> {
    return this.productList.asObservable();
  }

  setProductListSubject(status: boolean) {
    this.productList.next(status);
  }

  getCategories(filters?): Observable<Category[]> {
    return this.eGiftCardsGatewayService.getCategories(filters);
  }

  getProductList(limit: number = 25, offset: number = 0, query_params?: QueryParams[]): Observable<ProductsResult> {
    return this.eGiftCardsGatewayService.getProductList(limit, offset, query_params)
  }

  getProductListByAdmin(query_params?: QueryParams[]): Observable<any> {
    return this.eGiftCardsGatewayService.getProductListByAdmin(query_params)
  }

  getOrders(filters?: any): Observable<OrderList> {
    return this.eGiftCardsGatewayService.getOrders(filters);
  }

  getOrdersArchive(filters?: any): Observable<OrderList> {
    return this.eGiftCardsGatewayService.getOrdersArchive(filters);
  }

  getOrdersByAdmin(filters?: any) {
    return this.eGiftCardsGatewayService.getOrdersByAdmin(filters);
  }

  resendOrder(id: number, use_account_email: boolean = false, use_sub_user_email: boolean = false) {
    return this.eGiftCardsGatewayService.resendOrder(id, use_account_email, use_sub_user_email);
  }

  getReport(reportParams: ReportParams): Observable<DigitalProductReport> {
    return this.eGiftCardsGatewayService.getReport(reportParams);
  }

  getUserReport(reportItems: ReportParams): Observable<DigitalProductReport> {
    return this.eGiftCardsGatewayService.getUserReport(reportItems);
  }

  getUserDetail(userId: number): Observable<User> {
    return this.eGiftCardsGatewayService.getUserDetail(userId);
  }

  getProductDetail(productId: number): Observable<Product> {
    return this.eGiftCardsGatewayService.getProductDetail(productId);
  }

  addToFavoriteSuggestions(productId: number): Observable<any> {
    return this.eGiftCardsGatewayService.addToFavoriteSuggestions(productId);
  }

  addToFavoriteProducts(productId: number): Observable<any> {
    return this.eGiftCardsGatewayService.addToFavoriteProducts(productId);
  }

  removeFromFavoriteSuggestions(productId: number) {
    return this.eGiftCardsGatewayService.removeFromFavoriteSuggestions(productId);
  }

  removeFromFavoriteProducts(productId: number) {
    return this.eGiftCardsGatewayService.removeFromFavoriteProducts(productId);
  }

  getFavoriteProducts(limit: number = 25, offset: number = 0, query_params?: QueryParams[]): Observable<any> {
    return this.eGiftCardsGatewayService.getFavoriteProducts(limit, offset, query_params);
  }

  getFavoriteSuggestions(limit: number = 25, offset: number = 0, query_params?: QueryParams[]): Observable<any> {
    return this.eGiftCardsGatewayService.getFavoriteSuggestions(limit, offset, query_params);
  }

  getCardSubjects(): Observable<any> {
    return this.eGiftCardsGatewayService.getCardSubjects();
  }

  downloadOrderExcelFile(id: number, code: string): Observable<Blob> {
    return this.eGiftCardsGatewayService.downloadOrderExcelFile(id, code);
  }

  downloadOrderReportExcelFile(filters: any): Observable<Blob> {
    return this.eGiftCardsGatewayService.downloadOrderReportExcelFile(filters);
  }

  getProductDetailByRegion(id: number, query_params?: QueryParams[]): Observable<any> {
    return this.eGiftCardsGatewayService.getProductDetailByRegion(id, query_params);
  }

  searchByProductTitle(query_params?: QueryParams[]): Observable<any> {
    return this.eGiftCardsGatewayService.searchByProductTitle(query_params);
  }

  getPriceListProducts(priceListId: number, excel: number = 0): Observable<any> {
    return this.eGiftCardsGatewayService.getPriceListProducts(priceListId, excel);
  }

}
